import { useMutation } from '@tanstack/react-query'

import { mutationWithFeedback } from '@/utils/toast'

export type DbMutation<TData, TVariables> = (
  variables: TVariables,
) => Promise<TData>

const useMutationWithFeedback = <TData, TVariables>({
  mutation,
  error,
  success,
  onSuccess,
  onSettled,
  loadingDescription = 'Saving...',
  hideLoadingToast,
}: {
  mutation: DbMutation<TData, TVariables>
  error: string
  success: string
  onSuccess?: (data: TData) => Promise<void> | void
  onSettled?: Parameters<
    typeof useMutation<TData, Error, TVariables>
  >['0']['onSettled']
  loadingDescription?: string
  hideLoadingToast?: boolean
}) =>
  useMutation({
    mutationFn: async (variables: TVariables) =>
      mutationWithFeedback({
        mutation: mutation(variables),
        successText: success,
        errorText: error,
        loadingText: loadingDescription,
        hideLoadingToast,
      }),
    onSuccess: async (data) => {
      if (onSuccess) {
        await onSuccess(data)
      }
    },
    onSettled: onSettled,
  })

export default useMutationWithFeedback
